const cursorShift = () => {
    const followers = document.querySelectorAll('.follower')

    if (!followers.length) return

    window.addEventListener('mousemove', (e) => {
        const { innerWidth } = window
        const x = e.clientX

        Array.from(followers).forEach((el) => {
            const { range = 50 } = el.dataset

            // Map mouse X (0 to innerWidth) into -50px to 50px range
            const moveX = (x / innerWidth) * 100 - range

            el.style.setProperty('--follower-move-x', `${-moveX}px`)
        })
    })
}

export default cursorShift
